import { id } from 'date-fns/locale';
import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { CCTCuenta, CCTCuentaFormValues } from '../models/CCTCuenta';
import { store } from './store';

export default class CuentaDPIStore {
    CCTCuentaRegistry = new Map<any, CCTCuenta>();
    

    selectedCCTCuenta: CCTCuenta | undefined = undefined;

    editMode = false;
    loading = false;
    loadingInitial = false;
    saldo_actual_total:string = ""
    condicion = false

    constructor() {
        makeAutoObservable(this)
    }

    get CCTCuentaByCodigo() {
        return Array.from(this.CCTCuentaRegistry.values());
    }

    get groupedCCTCuentas() {
        return this.CCTCuentaRegistry
    }

    loadCCTCuentas = async () => {
        this.loadingInitial = true;
        try {
            const CCTCuentas: CCTCuenta[] = await agent.CCTCuentas.list();
            this.condicion = true
            CCTCuentas.forEach(element => {
                this.setCCTCuenta(element);
            })
            this.setLoadingInitial(false);
        } catch (error) {
            this.setLoadingInitial(false);
        }
    }

    private setCCTCuenta = (data: CCTCuenta) => {  
        this.CCTCuentaRegistry.set(data.id, data);
    }

    private getCCTCuenta = (idCliente: any) => {
        return this.CCTCuentaRegistry.get(idCliente);
    }

    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }
}